import React from 'react';
import { FaChevronDown, FaDatabase } from 'react-icons/fa';
import { getBadgeProps } from '../../../utils/common-utils';
import '../Navix.css';

/**
 * LayerPanel component for displaying layer models
 */
const LayerPanel = ({ 
  selectedLayer, 
  layerModels, 
  loadingModels, 
  hasMoreModels, 
  loadMoreLayerModels, 
  handleOpenPopup,
  setIsPanelVisible
}) => {
  // Helper function to get source-specific styling
  const getSourceStyle = (source) => {
    const badgeProps = getBadgeProps(source);
    return {
      borderColor: badgeProps.backgroundColor,
      backgroundColor: `${badgeProps.backgroundColor}20`, // 20% opacity
      iconColor: badgeProps.backgroundColor,
      textColor: '#FFFFFF' // Brighter white text
    };
  };

  return (
    <div className="counties-panel visible">
      <div className="panel-header">
        <h3>{selectedLayer}</h3>
        <button 
          className="close-panel"
          onClick={() => setIsPanelVisible(false)}
          aria-label="Close panel"
        >
          ×
        </button>
      </div>
      <div className="models-section">
        {loadingModels && layerModels.length === 0 ? (
          <div className="loading-models">
            <div className="spinner-small"></div>
            <span>Loading Models...</span>
          </div>
        ) : layerModels.length > 0 ? (
          <>
            <div className="models-list">
              {layerModels.map((model, index) => {
                const sourceStyle = getSourceStyle(model.source_application);
                return (
                  <div 
                    key={index} 
                    className="model-item"
                    onClick={() => handleOpenPopup(model)}
                    style={{
                      borderLeft: `4px solid ${sourceStyle.borderColor}`
                    }}
                  >
                    <div className="model-content">
                      <div className="model-header">
                        <div className="model-name" style={{ color: sourceStyle.textColor }}>
                          {model.name}
                        </div>
                        {model.source_application && (
                          <div 
                            className="model-source"
                            style={{ color: sourceStyle.iconColor }}
                          >
                            <FaDatabase size={12} />
                            <span>&nbsp; {model.source_application.toUpperCase()}</span>
                          </div>
                        )}
                      </div>
                      <div className="model-description" style={{ color: sourceStyle.textColor }}>
                        {model.description && model.description.length > 100 
                          ? `${model.description.substring(0, 100)}...` 
                          : model.description}
                      </div>
                    </div>
                    <div className="model-action-icon" style={{ color: sourceStyle.textColor }}>
                      <FaChevronDown />
                    </div>
                  </div>
                );
              })}
            </div>
            {hasMoreModels && (
              <div className="load-more-models">
                <button 
                  className="load-more-btn"
                  onClick={loadMoreLayerModels}
                  disabled={loadingModels}
                >
                  {loadingModels ? (
                    <div className="spinner-small"></div>
                  ) : (
                    <>
                      Load More <FaChevronDown />
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="no-models">
            No models found in this layer.
          </div>
        )}
      </div>
    </div>
  );
};

export default LayerPanel;
